import {ApiRequest, RequestMethod} from "../../../request";

const URL = "/api/weapon-trait";

export type CreateTraitResult = {
    id: string;
    name: string;
    description: string;
    commonStatus: number;
};

export async function createTrait(data: { name: string; description: string }): Promise<CreateTraitResult | null> {
    const apiRequest = new ApiRequest();
    apiRequest.setMethod(RequestMethod.POST);
    apiRequest.setUrl(URL);
    apiRequest.setJsonBody(data);

    const response: any = await apiRequest.send();

    if (response.status === 200) {
        return {
            id: response.data["id"],
            name: response.data["name"],
            description: response.data["description"],
            commonStatus: response.data["commonStatus"],
        };
    }

    return null;
}